import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import * as Actions from '../actions';
import Settings from '../lib/settings';

class Articles extends Component {

  constructor(props) {
    super(props);
    this.state = {

      articles: []

    };
  }

  componentDidMount() {
    //this.props.dispatch(Actions.loader(true));
    fetch('/api/articles/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {
      this.props.dispatch(Actions.loader(false));
      if (json.articles !== null) {
        this.setState({articles: json.articles});
      }
    });
    window.scrollTo(0, this.props.menuPosition);
  }

  handleDelete(slug, i) {
    let canDelete = window.confirm("Opravdu chcete smazat produkt?");
    if (canDelete) {
      //this.props.dispatch(Actions.loader(true));
      fetch("/api/articles/" + slug, Settings.fetchParams('DELETE')).then(res => {
        this.props.dispatch(Actions.loader(false));
        if (res.ok) {
          res.json().then(json => {
            if (!json.error && json.deleted) {

              let articles = this.state.articles;
              articles.splice(i, 1);
              this.setState({articles: articles});

            } else {
              console.log("Error");
            }
          })
        } else {
          alert("Error");
        }
      });

    }
  }

  render() {

    const articles = this.state.articles.map((item, index) =>
      <h2 key={index}>{item.name}<Link to={"/addarticle/" + item.slug}><i className="fas fa-edit"></i></Link> <i className="fas fa-trash-alt" onClick={() => this.handleDelete(item.slug, index)}></i></h2>
    );

    return (
      <div className="articles">
        <h1>Články</h1>
        <h2><Link to="/addarticle">Přidat nový článek</Link></h2>
        <div className="col100">
            {articles}

        </div>
      </div>); } }

      function mapStateToProps(state){
        return {admin: state.admin, menuPosition: state.menuPosition};
      }
      export default connect(mapStateToProps)(Articles);



// WEBPACK FOOTER //
// ./src/pages/Articles.js